import { AxiosError } from "axios";
import { AuthError } from "./authTypes";

type ErrorResponse = { message?: string; code?: string };

export const toAuthError = (error: unknown): AuthError => {
  const axiosError = error as AxiosError<ErrorResponse>;
  const status = axiosError.response?.status;
  const serverMessage = axiosError.response?.data?.message;
  const serverCode = axiosError.response?.data?.code;

  if (
    [
      "TOKEN_MISSING",
      "TOKEN_EXPIRED",
      "TOKEN_INVALID",
      "AUTH_TYPE_INVALID",
    ].includes(serverCode || "")
  ) {
    return {
      code: "SESSION_INVALID",
      message: serverMessage || "Your session is no longer valid.",
    };
  }

  if (serverCode === "ACCOUNT_INACTIVE") {
    return {
      code: "ACCOUNT_INACTIVE",
      message: serverMessage || "This account is inactive.",
    };
  }

  if (!axiosError.response) {
    return {
      code: "NETWORK_ERROR",
      message:
        "Unable to reach the server. Check your connection and try again.",
    };
  }

  if (status === 401) {
    return {
      code: "INVALID_CREDENTIALS",
      message: serverMessage || "The email or password is incorrect.",
    };
  }

  if (status === 429) {
    return {
      code: "RATE_LIMITED",
      message: serverMessage || "Too many attempts. Please wait and try again.",
    };
  }

  return {
    code: "UNKNOWN",
    message: serverMessage || "Authentication failed. Please try again.",
  };
};
